import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class MalwareScanActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  protected canRunOnCompanionRecords = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    const isSva: boolean = !!record.specifics.isSva;
    const isGhostr: boolean = !!record.specifics.isGhostr;
    const isNsva: boolean = !!record.specifics.isNsva;
    const isSandboxAnalyzer: boolean = !!record.specifics.isSandboxAnalyzer;

    if (record.specifics.serverHasNsxIntegration) {
      return true;
    }

    if (isSva || isGhostr || isNsva || isSandboxAnalyzer) {
      return false;
    }

    if (ProtectedEntitiesHelper.isComputer(record) && !record.specifics.isManaged) {
      return false;
    }

    if (ProtectedEntitiesHelper.isManagedByHviAndNotIsBest(record)) {
      return false;
    }

    if (ProtectedEntitiesHelper.isAwsInstance(record) && ProtectedEntitiesHelper.isPowerStateTerminated(record)) {
      return false;
    }

    if (record.isProtectedBySecurityContainer) {
      return false;
    }

    return true;
  }
}
